"use client";

import { useAuth } from "@clerk/react";
import { useEffect } from "react";

import { clearClerkTokenGetter, setClerkTokenGetter } from "~/store/clerkToken";

export const InitClerkToken = () => {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    setClerkTokenGetter(async () => {
      return (await getToken()) ?? null;
    });

    return () => {
      clearClerkTokenGetter();
    };
  }, [getToken, isLoaded]);

  return null;
};
